import React, { useEffect, useState } from "react";
import { GoArrowLeft } from "react-icons/go";
import DoctorTab from "./Utility/DoctorTab";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FiEdit, FiPrinter, FiDownload, FiUserCheck } from "react-icons/fi";
import { MdDelete, MdOutlineEmail, MdOutlinePhone, MdOutlineWorkOutline } from "react-icons/md";
import { useLazyGetdoctorQuery } from "../State/Api/AdddocApiSlice";
import { FaStar, FaRegStar, FaHeart, FaDollarSign, FaRegEdit } from "react-icons/fa";
import { GrContactInfo } from "react-icons/gr";
import dayjs from "dayjs";
import PatientAppointments from "./Utility/PatientAppointments";
import DoctortOverview from "./Utility/DoctorOverview";

function DoctorProfile() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");
  const { id: doctorId } = useParams();
  const [fetchDoctorView, { data: doctorViewData, isFetching, failed, isLoading, isError }] =
    useLazyGetdoctorQuery();

  useEffect(() => {
    if (doctorId) {
      fetchDoctorView(doctorId);
    }
  }, [doctorId]);

  const query = new URLSearchParams(location.search);
  const from = query.get("from");

  const handleBack = () => {
    if (from) {
      navigate(from);
    } else {
      navigate(-1);
    }
  };
  
const formatTimeToAMPM = (time) => {
  if (!time || time === "") return "";
  
  // Handle different time formats (HH:MM or HH:MM:SS)
  const timeParts = time.split(':');
  let hours = parseInt(timeParts[0]);
  const minutes = timeParts[1];
  
  // Determine AM or PM
  const ampm = hours >= 12 ? 'PM' : 'AM';
  
  // Convert to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // 0 should be 12
  
  return `${hours}:${minutes} ${ampm}`;
};

  const formatDate = (date) => {
    if (!date) return "";
    return dayjs(date)
      .format("DD-MMM-YYYY")
      .replace(
        /-(\w{3})-/,
        (_, month) =>
          `-${month.charAt(0).toUpperCase()}${month.slice(1).toLowerCase()}-`
      );
  };

  // Sample data matching the image
  const services = [
    { name: "Orthopedic consultation", price: "$220" },
    { name: "Delivery blocks", price: "$220" },
    { name: "Ultrasound injection", price: "$220" }
  ];

  const diseases = [
    "Orthopedic consultation",
    "Delivery blocks",
    "Ultrasound injection"
  ];

  const availability = [
    { day: "Wed Jun 16", time: "4:00 PM" },
    { day: "Wed Jun 16", time: "6:00 PM" },
    { day: "Thu Jun 17", time: "10:00 AM" },
    { day: "Thu Jun 17", time: "1:00 PM" },
    { day: "Fri Jun 18", time: "3:00 PM" }
  ];

  if (isLoading || isFetching) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-gray-500">Loading doctor details...</div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-red-600">Failed to load doctor details.</p>
      </div>
    );
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case "overview":
        return (
          <div style={{ padding: "20px 0" }}>
            {/* About specialist */}
            <div style={{ marginBottom: "40px" }}>
              <h3 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "15px" }}>
                About specialist
              </h3>
              <p style={{ lineHeight: "1.6", color: "#666", fontSize: "14px" }}>
  {`Dr. ${doctorViewData?.basicinfo?.fullname.trim()} is a highly experienced ${doctorViewData?.professionalinfo?.specialization} with over ${doctorViewData?.professionalinfo?.experience} years of medical practice. He earned his ${doctorViewData?.eductioncertificates[0]?.qualification.toUpperCase()} degree from ${doctorViewData?.eductioncertificates[0]?.university}, specializing in ${doctorViewData?.eductioncertificates[0]?.fieldofStudy}, and has developed a strong expertise in treating a wide range of ${doctorViewData?.professionalinfo?.specialization.toLowerCase()} cases. He is currently affiliated with ${doctorViewData?.basicinfo?.clinic_Hospital_Name}, where he is dedicated to providing advanced patient care and contributing to clinical excellence.`}
</p>
            </div>

            <div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
    marginBottom: "40px",
  }}
  className="doctor-info-grid"
>
  {/* Basic Information */}
  <div
    style={{
      border: "1px solid #e5e5e5",
      borderRadius: "8px",
      padding: "20px",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        marginBottom: "15px",
      }}
    >
      <FiUserCheck style={{ color: "#468ad6ff", marginRight: "8px" }} />
      <h4 style={{ fontSize: "16px", fontWeight: "600", margin: 0 }}>
        Basic Information
      </h4>
    </div>

    {[
      {
        label: "Date of Birth",
        value: doctorViewData?.basicinfo?.dateofbirth
          ? dayjs(doctorViewData.basicinfo.dateofbirth).format("DD-MMM-YYYY")
          : "-",
      },
      { label: "Gender", value: doctorViewData?.basicinfo?.gender },
      { label: "Phone Number", value: doctorViewData?.basicinfo?.phonenumber },
      {
        label: "Address",
        value: doctorViewData?.basicinfo?.office_clinicaddress,
      },
    ].map((item, i) => (
      <div
        key={i}
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "8px 0",
          fontSize: "14px",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <span style={{ color: "#666" }}>{item.label}</span>
        <span style={{ fontWeight: "600", color: "#333" }}>{item.value}</span>
      </div>
    ))}
  </div>

  {/* Professional Information */}
  <div
    style={{
      border: "1px solid #e5e5e5",
      borderRadius: "8px",
      padding: "20px",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        marginBottom: "15px",
      }}
    >
      <MdOutlineWorkOutline style={{ color: "#45c54bff", marginRight: "8px" }} />
      <h4 style={{ fontSize: "16px", fontWeight: "600", margin: 0 }}>
        Professional Information
      </h4>
    </div>

    {[
      {
        label: "Specialization",
        value: doctorViewData?.professionalinfo?.specialization,
      },
      {
        label: "Medical License Number",
        value: doctorViewData?.professionalinfo?.medicallicensenumber,
      },
      {
        label: "Years of Experience",
        value: `${doctorViewData?.professionalinfo?.experience || 0} Years`,
      },
      {
        label: "Languages",
        value: doctorViewData?.basicinfo?.languages_Known || "N/A",
      },
    ].map((item, i) => (
      <div
        key={i}
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "8px 0",
          fontSize: "14px",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <span style={{ color: "#666" }}>{item.label}</span>
        <span style={{ fontWeight: "600", color: "#333" }}>{item.value}</span>
      </div>
    ))}
  </div>

  {/* Inline CSS for responsiveness */}
  <style>
    {`
      @media (max-width: 768px) {
        .doctor-info-grid {
          grid-template-columns: 1fr !important;
        }
      }

      @media (max-width: 480px) {
        .doctor-info-grid div {
          padding: 15px !important;
        }

        .doctor-info-grid h4 {
          font-size: 15px !important;
        }
      }
    `}
  </style>
</div>


            {/* Availability */}
     <div>
  <h4
    style={{
      fontSize: "16px",
      fontWeight: "600",
      marginBottom: "15px",
    }}
  >
    Availability
  </h4>

  {doctorViewData?.clinicalrole?.timings && 
   doctorViewData.clinicalrole.timings.length > 0 ? (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(5, 1fr)",
        gap: "10px",
        marginBottom: "15px",
      }}
    >
      {doctorViewData.clinicalrole.timings.map((slot, index) => {
        const firstShift = `${formatTimeToAMPM(slot.startTime)} - ${formatTimeToAMPM(slot.endTime)}`;
        const secondShift =
          slot.startTime1 && slot.endTime1
            ? `${formatTimeToAMPM(slot.startTime1)} - ${formatTimeToAMPM(slot.endTime1)}`
            : null;

        return (
          <button
            key={index}
            style={{
              padding: "12px 8px",
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              background: "white",
              textAlign: "center",
              cursor: "pointer",
              fontSize: "13px",
              transition: "all 0.3s ease",
              boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.borderColor = "#4A90E2";
              e.currentTarget.style.backgroundColor = "#f0f8ff";
              e.currentTarget.style.transform = "scale(1.03)";
              e.currentTarget.style.boxShadow =
                "0 4px 10px rgba(74, 144, 226, 0.15)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.borderColor = "#e5e5e5";
              e.currentTarget.style.backgroundColor = "white";
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow =
                "0 1px 2px rgba(0, 0, 0, 0.05)";
            }}
          >
            <div style={{ fontWeight: "500", color: "#333" }}>
              {slot.weekdayName}
            </div>

            {/* First Shift */}
            <div
              style={{
                fontWeight: "600",
                color: "#000",
                marginTop: "4px",
              }}
            >
              {firstShift}
            </div>

            {/* Second Shift (if available) */}
            {secondShift && (
              <div
                style={{
                  fontWeight: "600",
                  color: "#000",
                  marginTop: "2px",
                }}
              >
                {secondShift}
              </div>
            )}
          </button>
        );
      })}
    </div>
  ) : (
    <div
      style={{
        padding: "20px",
        textAlign: "center",
        color: "#666",
        fontSize: "14px",
        border: "1px solid #e5e5e5",
        borderRadius: "8px",
        backgroundColor: "#f9f9f9",
        marginBottom: "15px",
      }}
    >
      No Availability Timings
    </div>
  )}
</div>
          </div>
        );

      case "opinions":
        return (
          <div style={{ padding: "20px 0" }}>
            <PatientAppointments
              doctorViewData={doctorViewData}
              doctorUserUniqueID={doctorViewData?.basicinfo?.useruniqueid}
            />
          </div>
        );

      case "experience":
        return (
          <div style={{ padding: "20px 0" }}>
            <DoctortOverview doctorViewData={doctorViewData} />
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f8f9fa", width: "100%", padding: "0 10px" }}>
  <div style={{ width: "100%", padding: "0px 0" }}>
    {/* Header - Full Width */}
    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "15px", marginBottom: "25px" }}>
      <button
        onClick={handleBack}
        style={{
          width: "40px",
          height: "40px",
          border: "1px solid #ddd",
          borderRadius: "6px",
          backgroundColor: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer"
        }}
      >
        <GoArrowLeft size={18} />
      </button>
      <div style={{ flex: "1 1 auto", minWidth: "150px" }}>
        <h1 style={{ fontSize: "24px", fontWeight: "600", margin: 0, color: "#333" }}>
          Doctor Profile
        </h1>
      </div>
    </div>

    {doctorViewData && (
      <>
        {/* Doctor Header Card */}
        <div style={{
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "25px",
          marginBottom: "20px",
          width: "100%",
          boxSizing: "border-box",
        }}>
          <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "15px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "15px", flex: "1 1 250px", minWidth: "250px" }}>
              <img
                src={doctorViewData?.basicinfo?.imageURL
                  ? doctorViewData.basicinfo.imageURL
                  : "https://www.freeiconspng.com/uploads/stethoscope-doctor-clipart-bag-illustration-symbol-doctors-png-13.png"}
                alt="Doctor"
                className="doctor-avatar"
                style={{
                  borderRadius: '8px',
                  width: "60px",
                  height: "60px",
                  flexShrink: 0
                }}
              />
              <div style={{ flex: "1 1 auto", minWidth: "120px" }}>
                <h2 style={{ fontSize: "24px", fontWeight: "600", margin: 0, marginBottom: "5px", color: "#333" }}>
                  {doctorViewData?.basicinfo?.fullname || "Przemysław Czaja"}
                </h2>
                <p style={{ fontSize: "16px", color: "#666", margin: 0, marginBottom: "8px" }}>
                  {doctorViewData?.professionalinfo?.specialization || "Cardiology Specialist"}
                </p>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", fontSize: "14px" }}>
                  <span className={`px-3 py-1 rounded-full text-white text-xs font-semibold ${doctorViewData?.basicinfo?.isactive === "Available" ? "bg-green-500" : "bg-red-500"}`}>
                    {doctorViewData?.basicinfo?.isactive || "-"}
                  </span>
                  <span style={{ display: "flex", alignItems: "center", gap: 5, minWidth: "120px" }}><MdOutlineEmail />{doctorViewData?.basicinfo?.emailaddress}</span>
                  <span style={{ display: "flex", alignItems: "center", gap: 5, minWidth: "120px" }}><MdOutlinePhone />+{doctorViewData?.basicinfo?.phonenumber}</span>
                </div>
              </div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
              <button style={{ display: 'flex', alignItems: 'center', gap: 5 }} 
                onClick={() => {
                  navigate(`/DoctorsAdd/${doctorViewData?.basicinfo?.useruniqueid}?from=${encodeURIComponent(location.pathname + location.search)}`);
                }}
                className="gradient-dark-button"
              >
                <div><FaRegEdit /></div><div>Edit</div>
              </button>
              <button 
                onClick={() => {
                  navigate("/AddAppointment", { state: { showModal: true, doctorName: doctorViewData?.basicinfo?.fullname, doctorSpecialization: doctorViewData?.professionalinfo?.specialization, fromDoctorView: true,from: location.pathname } })
                }}
                className="gradient-button"
              >
                Make Appointment
              </button>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div style={{ backgroundColor: "white", width: "100%", padding: "0px 10px", marginBottom: "20px" }}>
          <div style={{ display: "flex", flexWrap: "wrap", borderBottom: "1px solid #e5e5e5" }}>
            {[
              { id: "overview", label: "Overview" },
              { id: "opinions", label: "Appointment History" },
              { id: "experience", label: "Experience & Education" }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "15px 25px",
                  border: "none",
                  backgroundColor: "transparent",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  borderBottom: activeTab === tab.id ? "2px solid #4A90E2" : "2px solid transparent",
                  color: activeTab === tab.id ? "#4A90E2" : "#666",
                  flex: "1 1 auto",
                  textAlign: "center",
                  minWidth: "120px"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div style={{ backgroundColor: "white", padding: "0 25px 25px 25px", width: "100%", boxSizing: "border-box" }}>
          {renderTabContent()}
        </div>
      </>
    )}
  </div>
</div>
  );
}

export default DoctorProfile;
